import ThisModule from "./SelectedEventSummary";

export default ThisModule;
